import { Suspense, useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import CharacterDetail from '~/components/CharacterDetails/CharacterDetail/CharacterDetail';
import { CharacterDetailsSubMenu, Header } from '~/components/common/Header';
import CharacterDetailsSkeleton from '~/components/common/Skeleton/CharacterDetailsSkeleton';

export default function CharacterDetails() {
  const [showBlockCharacter, setShowBlockCharacter] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const CharacterDetailsHeader = () => (
    <Header.Root style={{ padding: '0 10px 0 0' }}>
      <Header.Section>
        <Header.PrevButton />
        <Header.Title>Character details</Header.Title>
      </Header.Section>
      <Header.Section>
        <CharacterDetailsSubMenu
          setShowBlockCharacter={setShowBlockCharacter}
        />
      </Header.Section>
    </Header.Root>
  );

  return (
    <>
      <CharacterDetailsHeader />
      <Suspense fallback={<CharacterDetailsSkeleton />}>
        <Sentry.ErrorBoundary fallback={undefined}>
          <CharacterDetail
            showBlockCharacter={showBlockCharacter}
            setShowBlockCharacter={setShowBlockCharacter}
          />
        </Sentry.ErrorBoundary>
      </Suspense>
    </>
  );
}
